import { render, staticRenderFns } from "./InfoList.vue?vue&type=template&id=19665133&scoped=true&"
import script from "./InfoList.vue?vue&type=script&lang=ts&"
export * from "./InfoList.vue?vue&type=script&lang=ts&"
import style0 from "./InfoList.vue?vue&type=style&index=0&id=19665133&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19665133",
  null
  
)

export default component.exports